import React from 'react';

import './header.css'
import './../layout/popup.css'
import HeadingBlock from '../common/heading';

const Header = (props) => {
    return ( <>
        <header className={props.class}>
        <HeadingBlock label={props.label} heading={props.heading} style1={props.style1} subbheading={props.subheading} />
           
    </header>
    </> );
}
 
export default Header;